import { ModuleFE_EHRInstallation } from './ModuleFE_EHRInstallation.js';
export const ModulePackFE_EHRInstallation = [ModuleFE_EHRInstallation];
//# sourceMappingURL=module-pack.js.map